import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { ProductByHandleQuery } from "../../../../lib/shopify/sdk";
import { NestedOptions } from "./NestedOptions";
import { RegularOptions } from "./RegularOptions";
import { SingleOption } from "./SingleOption";

interface Props {
  product: ProductByHandleQuery["productByHandle"];
}

export const OptionSelector = ({ product }: Props) => {
  const { query, isReady, replace } = useRouter();
  const autoDiscount =
    product?.autoDiscount?.value && product?.autoDiscount?.value !== "0"
      ? String(product?.autoDiscount?.value)
      : null;
  const mostPopularVariant = product?.mostPopularVariant?.value;
  const isNested = product.isNested?.value;
  const once = useRef(true);
  const convertVariants = () => {
    const variants = {};
    const refillVariants = {};
    product.variants.edges.forEach(({ node }) => {
      const isRefill = node?.refill?.value;
      if (isRefill) {
        const value = refillVariants[node.selectedOptions[0].value];
        if (!value) refillVariants[node.selectedOptions[0].value] = [node];
        else
          refillVariants[node.selectedOptions[0].value] = [
            ...refillVariants[node.selectedOptions[0].value],
            node,
          ];
      } else {
        const value = variants[node.selectedOptions[0].value];
        if (!value) variants[node.selectedOptions[0].value] = [node];
        else
          variants[node.selectedOptions[0].value] = [
            ...variants[node.selectedOptions[0].value],
            node,
          ];
      }
    });
    return [Object.entries(variants), Object.entries(refillVariants)];
  };
  const [regularVariants, refillVariants] = convertVariants();
  useEffect(() => {
    if (isReady && !query?.variantId && once.current) {
      once.current = false;
      const firstInStock = product?.variants?.edges.find(
        (item) => item.node.availableForSale
      );
      const route = {
        query: {
          ...query,
          variantId: firstInStock
            ? firstInStock.node.id.replace(/gid:\/\/shopify\/.*\//i, "")
            : product.variants.edges[0].node.id.replace(
                /gid:\/\/shopify\/.*\//i,
                ""
              ),
        },
      };
      replace(route, undefined, { shallow: true });
    }
  }, [isReady, product]);
  if (product.options.length === 1 && product.variants.edges.length > 1)
    return (
      <SingleOption
        options={product.options}
        refillVariants={refillVariants as any}
        regularVariants={regularVariants as any}
        autoDiscount={autoDiscount}
        mostPopularVariant={mostPopularVariant}
      />
    );
  if (isNested)
    return (
      <NestedOptions
        refillVariants={refillVariants as any}
        regularVariants={regularVariants as any}
        autoDiscount={autoDiscount}
        mostPopularVariant={mostPopularVariant}
        options={product.options}
      />
    );
  if (product.variants.edges.length > 1)
    return (
      <RegularOptions
        options={product.options}
        regularVariants={regularVariants}
        refillVariants={refillVariants}
        autoDiscount={autoDiscount}
        mostPopularVariant={mostPopularVariant}
      />
    );
  return null;
};
